@if (data(); as data) {
  <div class="main-intro-video {{ data.styleClasses }}">
    @if (data.image) {
      <app-gg-media-with-mobile-media
        [container]="data.image"
        [mobileContainer]="data.mobileImage"
      ></app-gg-media-with-mobile-media>
    } @else {
      <img [src]="youtubeService.getThumbnailUrl(data.videoLink)" alt="" />
    }
    @if (consent()) {
      <button
        type="button"
        tabindex="0"
        class="video-play"
        (click)="toggleVideo(true)"
        (keydown.enter)="toggleVideo(true)"
        [attr.title]="'common.playVideo' | cxTranslate"
        [attr.aria-label]="'common.playVideo' | cxTranslate"
      >
        <svg width="45" height="45" viewBox="0 0 15 15">
          <path d="M3 13q0 2 2 1l8-5q1-1 0-2L5 2Q3 1 3 3Z" />
        </svg>
      </button>
    } @else {
      <app-gg-cookie-consent-message [videoStyleClass]="'video-cookie-consent'"></app-gg-cookie-consent-message>
    }

    @if (toggledVideo() && consent()) {
      <iframe
        title="YouTube video player"
        frameborder="0"
        allow="autoplay"
        allowfullscreen
        [cachedSrc]="youtubeService.getEmbedUrl(data.videoLink)"
      ></iframe>
    }
  </div>
}
